import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { GenerateService } from "src/app/shared/generate/generate.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SEARCH_INFORMATIONS_API_CONSTANT } from "src/app/shared/constant/api-constant";
import { CommonService } from "../../service/common.service";
import { CONSTANT, LOADING_KEY } from "src/app/shared/constant/constant";
import { LoadingState } from "../../html-parts/loading/loading-state";
import { TreeNode } from "primeng/api";
import { CONSULTATION_M701_TEMPLATE } from "manager/template-constant";

@Component({
  selector: "app-generate-search",
  templateUrl: "./generate-search.component.html",
  styleUrls: ["./generate-search.component.scss"],
})

/**
 * 検索項目情報
 */
export class GenerateSearchComponent implements OnInit {
  // インプット.検索項目生成エンドポイント
  @Input() searchEndPoint: string;

  // インプット.検索項目生成テンプレートID
  @Input() searchTemplateId: number;

  // 検索ボタン名
  // 未設定時のボタン名は検索
  @Input() searchButtonName: string = "検索";

  // 日付 and 数値の表示形式変換
  // 未設定時の開始and終了の縦に表示
  @Input() changeFromToDisplay: boolean;

  // アウトプット.検索フォーム
  @Output() generateSearchInformation = new EventEmitter<FormGroup>();

  @Output() openTab = new EventEmitter<boolean>(false);

  // 画面.検索フォーム
  generateSearchForm: FormGroup = this.formBuilder.group(Object());

  // 画面.検索項目生成
  generateSearchList: any[];
  listCategory: any[] = [];
  selectedCategory: any[] = [];
  subCategory1: any[] = [];
  listSubCategory1: any[] = [];
  subCategory2: any[] = [];
  listSubCategory2: any[] = [];
  listSubCategory: any[] = [];

  organizationDetailList: any[] = []
  organizationDetail: any[] = []
  isM701: boolean = false;
  listSelected: any = {};

  // 初期化/宣言
  constructor(
    private generateService: GenerateService,
    private commonService: CommonService,
    private loadingState: LoadingState,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void { }

  // 画面初期表示 or @Input変更時
  ngOnChanges(): void {
    // 検索項目生成を初期化
    this.generateSearchList = new Array();

    // 検索フォームを初期化
    this.generateSearchForm = this.formBuilder.group(Object());

    // 検索項目生成を実施
    this.getGenerateSearch();
  }

  /**
   * 検索項目生成
   */
  private getGenerateSearch(): void {

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.GENERATE_SEARCH);

    // 検索項目情報取得処理
    this.generateService
      .getGenerateSearch(this.searchEndPoint, this.searchTemplateId)
      .subscribe((response) => {
        // 検索項目情報が取得されたか否か
        if (this.commonService.checkNoneResponse(response)) {
          // 検索項目情報が取得されなかった場合

          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadEnd(LOADING_KEY.GENERATE_SEARCH);

          return;
        }

        // 検索項目情報を画面.検索項目生成に格納
        this.generateSearchList = response.body

        // 検索フォーム用コントロール作成
        for (const generateSearchItems of response.body) {
          if (generateSearchItems.column_id == "agenda_category_class_cd1") {
            this.listCategory = generateSearchItems.code_list_multi.map(
              (value: any) => {
                return {
                  name: value.class_name1,
                  value: value.value,
                  children: value.cd2.map((child1: any) => {
                    return {
                      name: child1.class_name2,
                      value: child1.value,
                    };
                  }),
                };
              }
            );
          } else if (generateSearchItems.column_id == "member_class_sub_id") {
            this.organizationDetail = this.organizationDetailList = generateSearchItems.code_list_multi
          }

          // 検索項目タイプの判定
          if (
            SEARCH_INFORMATIONS_API_CONSTANT.DATE_TYPE ==
            generateSearchItems.search_type ||
            SEARCH_INFORMATIONS_API_CONSTANT.NUMBER_TYPE ==
            generateSearchItems.search_type
          ) {
            // 検索項目タイプが"date" or "number"の場合
            this.generateSearchForm.addControl(
              generateSearchItems.column_id + "_FROM",
              this.formBuilder.control(CONSTANT.EMPTY_STRING, [])
            );

            this.generateSearchForm.addControl(
              generateSearchItems.column_id + "_TO",
              this.formBuilder.control(CONSTANT.EMPTY_STRING, [])
            );
          } else {
            // 検索項目タイプが"date" or "number"以外の場合
            this.generateSearchForm.addControl(
              generateSearchItems.column_id,
              this.formBuilder.control(CONSTANT.EMPTY_STRING, [])
            );
          }
          this.listSelected[generateSearchItems.column_id] = false
        }
        if (this.searchTemplateId == 3702) {
          this.generateSearchForm.addControl(
            "freeword",
            this.formBuilder.control(CONSTANT.EMPTY_STRING, [])
          );
        }
        if (this.searchTemplateId == CONSULTATION_M701_TEMPLATE.SEARCH_TEMPLATE_ID) {
          this.isM701 = true;
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadEnd(LOADING_KEY.GENERATE_SEARCH);
      });
  }

  /* 検索ボタン押下 */
  public onSubmit() {
    const defaultInputValue: object = new Object();
    // 画面.検索フォームを親コンポーネントへ値を渡す
    for (const generateSearchItems of this.generateSearchList) {
      // if (generateSearchItems.column_id == "category") {
      //   this.generateSearchForm.controls[
      //     generateSearchItems.column_id
      //   ].setValue(
      //     this.selectedCategory
      //       .map((val) => {
      //         return val.value;
      //       })
      //       .join(CONSTANT.COMMA)
      //   );
      // }
      // 検索項目タイプの判定

      if (SEARCH_INFORMATIONS_API_CONSTANT.TEXT_TYPE == generateSearchItems.search_type) {
        const valueSearch = (this.generateSearchForm.value[generateSearchItems.column_id] || '').trim()
        this.generateSearchForm.controls[
          generateSearchItems.column_id
        ].setValue(valueSearch);
      }
      if (
        SEARCH_INFORMATIONS_API_CONSTANT.DATE_TYPE ==
        generateSearchItems.search_type &&
        this.generateSearchForm.value[
        generateSearchItems.column_id + "_FROM"
        ] == null
      ) {
        // set value from null to empty string with date
        this.generateSearchForm.controls[
          generateSearchItems.column_id + "_FROM"
        ].setValue(CONSTANT.EMPTY_STRING);
      }
      if (
        SEARCH_INFORMATIONS_API_CONSTANT.DATE_TYPE ==
        generateSearchItems.search_type &&
        this.generateSearchForm.value[generateSearchItems.column_id + "_TO"] ==
        null
      ) {
        // set value from null to empty string with date
        this.generateSearchForm.controls[
          generateSearchItems.column_id + "_TO"
        ].setValue(CONSTANT.EMPTY_STRING);
      }
      if (
        SEARCH_INFORMATIONS_API_CONSTANT.NUMBER_TYPE ==
        generateSearchItems.search_type &&
        this.generateSearchForm.value[
        generateSearchItems.column_id + "_FROM"
        ] == null
      ) {
        // set value from null to empty string with date
        this.generateSearchForm.controls[
          generateSearchItems.column_id + "_FROM"
        ].setValue(CONSTANT.EMPTY_STRING);
      }
      if (
        SEARCH_INFORMATIONS_API_CONSTANT.NUMBER_TYPE ==
        generateSearchItems.search_type &&
        this.generateSearchForm.value[generateSearchItems.column_id + "_TO"] ==
        null
      ) {
        // set value from null to empty string with date
        this.generateSearchForm.controls[
          generateSearchItems.column_id + "_TO"
        ].setValue(CONSTANT.EMPTY_STRING);
      }
      Object.keys(this.generateSearchForm.controls).forEach(key => {
        let value = this.generateSearchForm.get(key)?.value;
        if (key === 'freeword' && typeof value === 'string') {
          value = value.trim();
          this.generateSearchForm.get(key)?.setValue(value);
        }
      });
    }
    this.generateSearchInformation.emit(this.generateSearchForm.value);
  }

  /**
   * クリアボタン押下
   */
  public reset() {
    // デフォルト入力値オブジェクトを生成
    const defaultInputValue: object = new Object();

    // 検索項目情報をループ
    for (const generateSearchItems of this.generateSearchList) {
      // 検索項目タイプの判定
      if (generateSearchItems.column_id == 'agenda_category_class_cd2') {

        this.listSubCategory = [];
      }
      if (
        SEARCH_INFORMATIONS_API_CONSTANT.DATE_TYPE ==
        generateSearchItems.search_type ||
        SEARCH_INFORMATIONS_API_CONSTANT.NUMBER_TYPE ==
        generateSearchItems.search_type
      ) {
        // 検索項目タイプが"date" or "number"の場合
        defaultInputValue[generateSearchItems.column_id + "_FROM"] =
          CONSTANT.EMPTY_STRING;

        defaultInputValue[generateSearchItems.column_id + "_TO"] =
          CONSTANT.EMPTY_STRING;
      } else {
        // 検索項目タイプが"date" or "number"以外の場合
        defaultInputValue[generateSearchItems.column_id] =
          CONSTANT.EMPTY_STRING;
      }
    }
    this.listSubCategory1 = [];
    this.listSubCategory2 = [];
    this.selectedCategory = [];
    this.organizationDetail = this.organizationDetailList
    // フォーム入力値をクリア
    this.generateSearchForm.reset(defaultInputValue);
  }

  onChangCategory(event: any) {
    this.generateSearchForm.controls['agenda_category_class_cd2'].setValue(CONSTANT.EMPTY_STRING);
    const listselectdCategory = this.listCategory.filter((valCategory: any) => {
      return event.value.indexOf(valCategory.value) !== -1;
    });
    const listSubcategory = listselectdCategory.map((val) => {
      return val.children;
    });
    if (listSubcategory.length > 0) {
      this.listSubCategory = listSubcategory.reduce((accVal, currentVal) => {
        return accVal.concat(currentVal);
      });
    } else {
      this.listSubCategory = [];
    }
  }

  onChangeClassId(classId: string[]) {
    this.generateSearchForm.get("member_class_sub_id").setValue('')
    const isSingleClass = classId.length === 1;
    const isClassIdOne = classId[0] == "1";

    if (isSingleClass) {
      const filterCondition = isClassIdOne
        ? (i: any) => Number(i.value) < 6
        : (i: any) => Number(i.value) > 5;

      this.organizationDetail = this.organizationDetailList.filter(filterCondition);
    } else {
      this.organizationDetail = [...this.organizationDetailList];
    }
  }

  isDisabledTab(controlName) {
    const value = this.generateSearchForm.get(controlName).value;
    if (value == null) {
      return false;
    } else if (value.length > 0) return true;
    else return false;
  }
  /**
   * カテゴリ大項目
   * @param event チェック状態
   * @param list チェック対象小項目リスト
   */
  public checkLargeCategory(
    type: string,
    list: any,
    controlName: string
  ): void {
    // 画面.検索フォーム.カテゴリを取得
    let getList = this.generateSearchForm.get(controlName).value;

    // チェック対象小項目リストからコード値のみ取得
    let spCodeList = this.commonService.createArrayGetArrayObject(
      list,
      "value"
    );
    let result = [];
    // 該当のカテゴリコードを全て削除してresult変数に格納
    if (getList) {
      result = getList.filter((value) => !spCodeList.includes(value));
    }

    // チェック状態の判定

    // チェック状態の場合
    if (type == "checkAll") {
      // result変数に選択したカテゴリコードリストを追加
      result = result.concat(spCodeList);
    } else {
      result = result.filter((val) => !spCodeList.includes(val));
    }

    // 画面.検索フォーム.地域に設定
    this.generateSearchForm.get(controlName).setValue(result);
  }
  onPanelOpen(event: any) {
    this.openTab.emit(this.listSelected.member_municipalities)
  }
}
